export default function Twitter({ className }) {
  return (
    <svg
      width="31"
      height="25"
      viewBox="0 0 31 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M27.9 6.60987C27.9191 6.87777 27.9191 7.14572 27.9191 7.41362C27.9191 15.5848 21.6998 25 10.3327 25C6.83076 25 3.57759 23.9857 0.841064 22.2252C1.33863 22.2826 1.81699 22.3018 2.3337 22.3018C5.22326 22.3018 7.88326 21.3258 10.0074 19.661C7.29004 19.6035 5.01279 17.8239 4.22819 15.3744C4.61095 15.4317 4.99365 15.47 5.39555 15.47C5.95049 15.47 6.50549 15.3935 7.02214 15.2596C4.18996 14.6854 2.06575 12.1977 2.06575 9.1933V9.11678C2.88858 9.57606 3.84548 9.8631 4.85964 9.90133C3.19477 8.79139 2.10403 6.89691 2.10403 4.75362C2.10403 3.60545 2.41016 2.55295 2.94601 1.63439C5.98872 5.38513 10.5624 7.83455 15.6909 8.10251C15.5952 7.64323 15.5378 7.16487 15.5378 6.68645C15.5378 3.28012 18.2934 0.505371 21.7188 0.505371C23.4985 0.505371 25.106 1.25169 26.235 2.45729C27.632 2.18939 28.9715 1.67268 30.158 0.964649C29.6987 2.39991 28.7228 3.60551 27.4406 4.37091C28.6845 4.23702 29.8901 3.89249 31 3.41413C30.1581 4.63881 29.1056 5.72954 27.9 6.60987V6.60987Z" />
    </svg>
  );
}
